import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { permisopagina } from '../models/permisopagina';
import { map } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { perfil } from '../models/perfil';
import { environment } from 'src/environments/environment';

const httpOption = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Credentials': 'true',
    'Access-Control-Allow-Methods': 'GET,HEAD,OPTIONS,POST,PUT',
  }),
};

@Injectable({
  providedIn: 'root'
})
export class ProfileService {

  url = environment.baseUrl+ '/api/Perfil/';

  constructor(private http: HttpClient) {}

  getPerfiles(): Observable<perfil[]> {
    return this.http.post<perfil[]>(this.url+'GetPerfiles', {}, httpOption);
  }
  getPerfilesAdm(): Observable<perfil[]> {
    return this.http.post<perfil[]>(this.url+'GetPerfilesAdm', {}, httpOption);
  } 

  getPerfilesEmpleados(): Observable<perfil[]> {
    return this.http.post<perfil[]>(this.url+'GetPerfilesEmpleados', {}, httpOption);
  } 
}
